import { render, staticRenderFns } from "./OutsourcingTypeSelect.vue?vue&type=template&id=7126cc18&"
import script from "./OutsourcingTypeSelect.vue?vue&type=script&lang=js&"
export * from "./OutsourcingTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingTypeSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports